import styled from "styled-components";
import * as Colors from "../../styles/Colors";

export const OrionLogoBox = styled.div`
  background-color: ${Colors.primary.white};

  /* padding: 5px; */
`;
